/* eslint-disable import/prefer-default-export */
const createFetchFor =
  (init) =>
  async (url, params = {}) => {
    const { headers: HeaderParams = {}, ...rest } = params;

    const response = await fetch(url, {
      headers: {
        Accept: 'application/json',
        ...HeaderParams,
      },
      ...init,
      ...rest,
    });

    if (!response.ok) {
      const error = await response.json();
      //  Build an API error object
      const apiError = new Error(error.message || 'Request failed. Please try again.');
      apiError.name = 'ApiError';
      apiError.code = error.errorCode;
      apiError.type = error.errorType;
      apiError.status = response.status;
      apiError.ok = false;
      throw apiError;
    }
    return response.json();
  };

export const get = createFetchFor({ method: 'get' });
export const post = createFetchFor({ method: 'post' });
